import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-virtual-store-container',
  templateUrl: './virtual-store-container.component.html',
  styleUrls: ['./virtual-store-container.component.scss']
})
export class VirtualStoreContainerComponent implements OnInit {
  isClient: boolean = false;
  constructor(private authService: AuthService,
    private commonService: CommonService) { }

  ngOnInit() {
    if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) this.isClient = true;
  }

}
